module.exports = __webpack_public_path__ + "img/sunzhongshanjinianguan.ab764c0f.png";